import * as React from "react";
import { Icon, PopoverInteractionKind } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";

export const InfoTooltip = ({ children }: { children?: React.ReactNode }) => {
  return (
    <Popover2
      interactionKind={PopoverInteractionKind.HOVER}
      placement="top"
      content={children ? <>{children}</> : ""}
      popoverClassName="info-tooltip"
    >
      <Icon icon="info-sign" className="info-icon" />
    </Popover2>
  );
};
